function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
  id: "gro-path-1",
  points: "0 0 20.529 0 20.529 24.9996 0 24.9996"
}));

var _ref3 = /*#__PURE__*/React.createElement("g", {
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", {
  transform: "translate(12.000000, 1.000000)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M10.2646,22.1426 C13.6116,20.9446 15.6046,16.7706 16.6956,12.4996 L10.2646,12.4996 L10.2646,22.1426 Z",
  fill: "#FEFEFE"
}), /*#__PURE__*/React.createElement("path", {
  d: "M2.768,5.6973 C2.889,7.6523 3.218,10.0913 3.834,12.5003 L10.265,12.5003 L10.265,2.7703 C7.188,3.2533 3.616,4.5033 2.768,5.6973",
  fill: "#FEFEFE"
}), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("mask", {
  id: "gro-mask-2",
  fill: "white"
}, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#gro-path-1"
})), /*#__PURE__*/React.createElement("path", {
  d: "M10.2646,23.2246 C2.7746,20.9826 1.8146,7.1796 1.7246,5.4546 C2.6166,3.5346 7.3386,2.1696 10.2646,1.7306 C13.1906,2.1696 17.9136,3.5346 18.8046,5.4546 C18.7136,7.1796 17.7556,20.9826 10.2646,23.2246 L10.2646,23.2246 Z M20.4746,5.0166 C19.1616,1.3706 11.2816,0.1456 10.3856,0.0176 L10.2646,-0.0004 L10.1446,0.0176 C9.2496,0.1456 1.3676,1.3706 0.0556,5.0166 L-0.0004,5.1706 L0.0046,5.3336 C0.0276,6.0316 0.6556,22.4566 10.0456,24.9416 L10.2646,24.9996 L10.4846,24.9416 C19.8736,22.4566 20.5016,6.0316 20.5256,5.3336 L20.5296,5.1706 L20.4746,5.0166 Z",
  fill: "#FEFEFE",
  mask: "url(#gro-mask-2)"
}))));

var SvgGroupAccidentInsurance = function SvgGroupAccidentInsurance(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "45px",
    height: "28px",
    viewBox: "0 0 45 28",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgGroupAccidentInsurance, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/group-accident-insurance.b77d59e2.svg";
export { ForwardRef as ReactComponent };